<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <div class="flex rounded text-xs w-max ">

                    </div>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Transações <span v-if="divergence"> Divergentes </span>
                </h2>
            </div>
        </template>
        <div class="mt-4 pb-2">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="py-4 grid grid-cols-5 gap-4 ">
                    <div class="col-span-2" v-if="$page.props.user.scope === 'admin'">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Ver como:
                        </label>

                        <div class="inline-flex rounded-md shadow-sm" role="group">
                            <button type="button" class="py-2 px-4 text-sm font-medium text-gray-900 bg-white rounded-l-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': view !== 'admin'}" @click="view = 'admin'">
                                Admin
                            </button>
                            <button type="button" class="py-2 px-4 text-sm font-medium text-gray-900 bg-white rounded-r-md border border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': view !== 'other'}" @click="view = 'other'">
                                Cliente
                            </button>
                        </div>
                    </div>
                    <div class="col-span-3">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Clientes
                        </label>
                        <jet-auto-complete
                            id="contact" class="mt-1 block w-full"
                            :endpoint="'customers'"
                            :auto-load="true"
                            :custom-option="customCustomerView"
                            @input="reloadTransactions"
                            v-model="customerSelect"
                        />
                    </div>
                </div>

                <div class="py-4 grid grid-flow-col auto-cols-auto gap-4 rounded-lg" v-if="isShowWidgetTransactions">
                    <tgo-widget
                        color="purple"
                        icon="fa-receipt"
                        class="p-6 text-center">
                        <p class="text-xs">Total de transações</p>
                        <p class="text-2xl">{{ transactions.summary.transactions | number }}</p>
                    </tgo-widget>
                    <tgo-widget
                        color="blue"
                        icon="fa-coins"
                        class="p-6 text-center">
                        <p class="text-xs">Bruto</p>
                        <p class="text-2xl">{{ transactions.summary.total_amount | currency }}</p>
                    </tgo-widget>
                    <tgo-widget
                        color="green"
                        icon="fa-money-bill-wave"
                        class="p-6 text-center">
                        <p class="text-xs">Líquido</p>
                        <p class="text-2xl">{{ transactions.summary.net_value | currency }}</p>
                    </tgo-widget>
                    <tgo-widget
                        color="gray"
                        icon="fa-funnel-dollar"
                        class="p-6 text-center">
                        <p class="text-xs">Valor pendente</p>
                        <p class="text-2xl" v-if="(transactions.summary.status)">
                                <p class="text-2xl">
                                    {{ parseSummary(transactions.summary.status) | currency }}
                                </p>
                    </tgo-widget>
                    <tgo-widget
                        v-if="view === 'admin'"
                        color="yellow"
                        icon="fas fa-user-minus"
                        class="p-6 text-center">
                        <p class="text-xs">Transações divergentes</p>
                        <p class="text-2xl">{{ transactions.summary.adiq_diff }}</p>
                    </tgo-widget>
                </div>

                 <div>
                    <button class="my-5 items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                        @click="downloadTransaction">
                        <i class="fas fa-file-csv"></i>
                        Exportar XLSX
                    </button>
                </div>
                <div class="bg-white shadow-xl sm:rounded-lg px-4 py-4">
                    <flash :timeout="5000"/>
                    <inertia-table
                        :icon="null"
                        :data="transactions ? transactions : {list: []}"
                        :columns="columns[view]"
                        :filters="filters"
                        :params="params"
                        :enableDisplay="true"
                        id="id"
                        table-classes="text-xs"
                        routeName="acquiring.transactions"
                    >
                        <template slot-scope="row" slot="data_inicial_transacao">
                            {{ row.item.data_inicial_transacao | smallDateTime }}
                        </template>
                        <template slot-scope="row" slot="customer.name">
                            {{ row.item.customer.name | capitalizeName }}
                        </template>
                        <template slot-scope="row" slot="account_holder.name">
                            <div class="text-left w-full">
                                {{ row.item.account_holder ? row.item.account_holder.name : '' | capitalizeName }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="device.name">
                            <div class="text-leftt w-full" v-tippy :content="row.item.device.id">
                                {{ row.item.device.name || '' | capitalizeName }} ({{row.item.acquirer}})
                            </div>
                        </template>
                        <template slot-scope="row" slot="valor_total_transacao">
                            <div class="text-right w-full">{{ row.item.valor_total_transacao | currency }}</div>
                        </template>
                        <template slot-scope="row" slot="fee.adiq_amount">
                            <div v-if="row.item.fee" class="text-right w-full">
                                <div v-tippy :content="`Divergência: ${row.item.fee.adiq_diff.toFixed(2)}`"
                                    v-if="row.item.fee.adiq_diff >= 0.01 || row.item.fee.adiq_diff <= -0.01 "
                                    class="bg-red-500 text-white px-2 py-1 font-bold">
                                    {{ row.item.fee.adiq_amount | currency }}
                                </div>
                                <div v-else>{{ row.item.fee.adiq_amount | currency }}</div>
                            </div>
                        </template>
                        <template slot-scope="row" slot="fee.savings_amount">
                            <div v-if="row.item.fee" class="text-right w-full">
                                {{ row.item.fee.savings_amount || 0 | currency }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="fee.transaction_fee">
                            <div v-if="row.item.fee" class="text-right w-full">
                                {{ row.item.fee.transaction_fee || 0 | currency }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="fee.sub_amount">
                            <div v-if="row.item.fee" class="text-right w-full">
                                {{ row.item.fee.sub_amount | currency }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="fee.cac_amount">
                            <div v-if="row.item.fee" class="text-right w-full">
                                { row.item.fee.cac_amount | currency }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="fee.over_amount">
                            <div v-if="row.item.fee" class="text-right w-full">
                                {{ row.item.fee.over_amount | currency }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="fee.total_amount">
                            <div v-if="row.item.fee" class="text-right w-full">
                                {{ row.item.fee.total_amount | currency }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="valor_liquido_cliente">
                            <div class="text-right w-full">{{ row.item.valor_liquido_cliente | currency }}</div>
                        </template>
                        <template slot-scope="row" slot="instituicao_financeira">
                            <div class="text-center w-full" v-if="row.item.instituicao_financeira"><img
                                class="w-14 border border-gray-200 bg-white rounded-full p-1"
                                v-bind:src="`/images/credit-cards/lightcolor/${row.item.instituicao_financeira.toLowerCase()}.png`"/>
                            </div>
                        </template>
                        <template slot-scope="row" slot="status_transacao">
                            <div class="text-center" v-if="row.item.status_transacao">
                                <i class="fa-1_5x"
                                v-tippy
                                :content="row.item.status_transacao ? status[row.item.status_transacao].name : ''"
                                v-bind:class="status[row.item.status_transacao].icon"/>
                            </div>
                        </template>
                        <template slot-scope="row" slot="condicoes">
                            <div class="text-left w-full">{{ parseCondition(row.item) }}</div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>

        <Jet-dialog-modal :show="modalSelect" >
            <template #title>
                Selecione um cliente
            </template>
            <template #content>
                <div class="grid grid-cols-12 gap-4 ">
                    <div class="col-span-12">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Clientes
                        </label>
                        <jet-auto-complete
                            id="contact" class="mt-1 block w-full z-40"
                            :endpoint="'customers'"
                            :auto-load="true"
                            :custom-option="customCustomerView"
                            @input="reloadTransactions"
                            v-model="customerSelect"
                        />
                    </div>
                </div>
            </template>
             <template #footer>
                <jet-secondary-button @click.native="modalSelect = false">
                    Cancelar
                </jet-secondary-button>
            </template>
        </Jet-dialog-modal>

    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';
import TgoWidget from '../../Helpers/Widget';
import JetConfirmationModal from './../../Jetstream//ConfirmationModal';
import JetDialogModal from './../../Jetstream/DialogModal'
import JetSecondaryButton from './../../Jetstream/SecondaryButton'
import moment from 'moment/dist/moment';

export default {
    components: {
        JetSecondaryButton,
        JetDialogModal,
        JetConfirmationModal,
        TgoWidget,
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable
    },
    props: ['transactions','divergence','customer','devices'],
    data() {
        return {
            modalSelect: false,
            view: this.$page.props.user.scope === 'admin' ? 'admin' : 'other',
            columns: {
                admin: [
                    {text: 'Transação', className: 'text-left', key: 'data_inicial_transacao', sortable: true},
                    {text: 'Cliente', className: 'text-left', key: 'customer.name', sortable: false},
                    {text: 'Terminal', className: 'text-left', key: 'device.name', sortable: false},
                    {text: 'Bruto', className: 'text-right', key: 'valor_total_transacao', sortable: false},
                    {text: 'Adiq', className: 'text-right', key: 'fee.adiq_amount', sortable: false},
                    {text: 'Sub', className: 'text-right', key: 'fee.sub_amount', sortable: false},
                    {text: 'UN', className: 'text-right', key: 'fee.cac_amount', sortable: false},
                    {text: 'Over', className: 'text-right', key: 'fee.over_amount', sortable: false},
                    {text: 'Tx.Seg', className: 'text-right', key: 'fee.savings_amount', sortable: false},
                    {text: 'Taxa', className: 'text-right', key: 'fee.total_amount', sortable: false},
                    {text: 'Tx.Oper', className: 'text-right', key: 'fee.transaction_fee', sortable: false},
                    {text: 'Líquido', className: 'text-right', key: 'valor_liquido_cliente', sortable: false},
                    {text: 'Status', className: 'text-left', key: 'status_transacao', sortable: false},
                    {text: 'Condições', className: 'text-left', key: 'condicoes', sortable: false},
                    {text: 'Bandeira', className: 'text-center', key: 'instituicao_financeira', sortable: false},
                ],
                other: [
                    {text: 'Transação', className: 'text-left', key: 'data_inicial_transacao', sortable: true},
                    {text: 'Cliente', className: 'text-left', key: 'customer.name', sortable: false},
                    {text: 'Terminal', className: 'text-left', key: 'device.name', sortable: false},
                    {text: 'Bruto', className: 'text-right', key: 'valor_total_transacao', sortable: false},
                    {text: 'Taxa', className: 'text-right', key: 'fee.total_amount', sortable: false},
                    {text: 'Líquido', className: 'text-right', key: 'valor_liquido_cliente', sortable: false},
                    {text: 'Status', className: 'text-left', key: 'status_transacao', sortable: false},
                    {text: 'Condições', className: 'text-left', key: 'condicoes', sortable: false},
                    {text: 'Bandeira', className: 'text-center', key: 'instituicao_financeira', sortable: false},
                ],
            },
            status: {
                1: {
                    name: 'Pendente',
                    icon: 'fas fa-fw fa-clock text-yellow-500'
                },
                2: {
                    name: 'Em análise',
                    icon: 'fas fa-fw fa-clock text-yellow-400'
                },
                3: {
                    name: 'Pago',
                    icon: 'fas fa-fw fa-check text-blue-500'
                },
                4: {
                    name: 'Disponível',
                    icon: 'fas fa-fw fa-dollar-sign text-green-500'
                },
                5: {
                    name: 'Em disputa',
                    icon: 'fas fa-fw fa-comments-dollar text-blue-500'
                },
                6: {
                    name: 'Devolvida',
                    icon: 'fas fa-fw fa-exclamation-triangle text-blue-500'
                },
                7: {
                    name: 'Cancelado',
                    icon: 'fas fa-fw fa-minus-circle text-red-500'
                },
            },
            params: {
                sort: 'data_inicial_transacao:desc',
                page: 1,
                ...this.$page.props.queryString
            },
            filters: [
                {
                    text: 'Período por data de transação',
                    key: 'date',
                    type: 'date_interval',
                    colSpan: 3,
                },
                {
                    text: 'Status',
                    key: 'status_transacao',
                    type: 'dropdown',
                    colSpan: 1,
                    options: [
                        {id: '1', name: 'Aguardando pagamento'},
                        {id: '2', name: 'Em análise'},
                        {id: '3', name: 'Paga'},
                        {id: '4', name: 'Disponível'},
                        {id: '5', name: 'Em disputa'},
                        {id: '6', name: 'Devolvida'},
                        {id: '7', name: 'Cancelada'},
                    ]
                },
                {
                    key: 'quantidade_parcela',
                    text: 'Parcelas',
                    type: 'dropdown',
                    colSpan: 2,
                    options: [
                        {id: '1', name: '1'},
                        {id: '2', name: '2'},
                        {id: '3', name: '3'},
                        {id: '4', name: '4'},
                        {id: '5', name: '5'},
                        {id: '6', name: '6'},
                        {id: '7', name: '7'},
                        {id: '8', name: '8'},
                        {id: '9', name: '9'},
                        {id: '10', name: '10'},
                        {id: '11', name: '11'},
                        {id: '12', name: '12'},
                    ]
                },
                {
                    key: 'meio_pagamento',
                    text: 'Condição',
                    type: 'dropdown',
                    colSpan: 2,
                    options: [
                        {id: '3', name: 'Crédito'},
                        {id: '8', name: 'Débito'},
                    ]
                },
                {
                    key: 'device_id',
                    text: 'Terminal',
                    type: 'dropdown',
                    colSpan: 2,
                    options: this.devices.list.map(device => {
                        return {id: device.id, name: device.name + ' (' + device.serial_number + ')'}
                    })
                }
            ],
            scopes: {
                reseller: 'Revendedor',
                seller: 'Vendedor',
                holder: 'Estabelecimento',
                admin: 'Admin',
                partner: 'Parceiro',
                customer: 'Cliente',
                employee: 'Colaborador',
            },
            customerSelect:{}
        }
    },
    computed: {
        isShowWidgetTransactions(){
            return !this.divergence && this.transactions?.list.length > 0
        }
    },
    methods: {
        parseSummary(summary){
            let value = 0;
            summary.forEach(element => {
                if (element.status === 3) {
                    value = element.net_value;
                }
            });
            return value;
        },
        downloadTransaction: function () {

            let params = this.$page.props.queryString;

            if(!params.date || (!params.date.to && !params.date.from)){
                  this.$toast.open({
                    message: 'Por favor, selecione um período de início e fim para o gerar o relatório.',
                    type: 'warning',
                    duration: 5000,
                    position: 'top-right',
                    showCloseButtonOnHover: true
                });
                return;
            }

            if(moment(params.date.to).diff(moment(params.date.from), 'days') > 60){
                this.$toast.open({
                    message: 'Por favor, altere o período pois os relatorios não podem ser gerados com intervalos de mais de 60 dias.',
                    type: 'warning',
                    duration: 5000,
                    position: 'top-right',
                    showCloseButtonOnHover: true
                });
                return;
            }

            let endpoint = '/acquiring/export/transactions';
            let data = {
                params: JSON.stringify(this.$page.props.queryString)
            };
            let queryString = Object.keys(data).map(key => key + '=' + data[key]).join('&');
            window.location = endpoint + '?' + queryString;
        },
        reloadTransactions(e){
            if(e && e.id){
                this.$inertia.get(this.route('acquiring.transactions', {'customer_id':e.id}));
            }else{
                this.$inertia.get(this.route('acquiring.transactions',{'clear':true}));
            }

        },
        customCustomerView(option) {

            var name = option.name;
            var scopes = option.scope || [];

            scopes = scopes.map(scope => this.scopes[scope]).join(', ');

            return `
                <div class="flex items-center">
                    <div class="ml-3">
                        <div class="text-xs leading-none font-medium text-gray-900">${name}</div>
                        <div class="text-xs leading-none text-gray-500">${scopes}</div>
                    </div>
                </div>
            `;

        },
        showDivergence() {
            let aux = (this.removeParam("page", location.search)) ? '&' : '?';
            let url = '/acquiring/transactions' + this.removeParam("page", location.search) + aux + 'divergence=1';
            window.location.href = url;
        },
        removeParam(key, sourceURL) {
            var rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        },
        getLinkD() {
            return '/transactions?divergence=1?' + new URLSearchParams(this.params).toString();
        },
        show: function (item) {
            this.$inertia.get(this.route('transactions.show', item.id));
        },
        parseCondition: function (data) {
            switch (data.meio_pagamento) {
                case 3:
                    return 'Crédito '
                        + ((data.quantidade_parcela === 1) ? ' à vista' : `${data.quantidade_parcela} parcelas`);
                case 8:
                    return 'Débito ';
                case 11:
                    return 'PIX ';
                case '001':
                    return 'Crédito  à vista';
                case '002':
                    return 'Crédito ' + (`${data.quantidade_parcela} parcelas`);
                case '003':
                    return 'Crédito ' + (`${data.quantidade_parcela} parcelas`);
                case '008':
                    return 'Crédito ' + (`${data.quantidade_parcela} parcelas`);
                case '005':
                    return 'Débito ';
                default:
                    return 'Voucher ';
            }
        },

    },
    created() {
        if(!this.customer){
            this.modalSelect = true;
        }else{
            this.customerSelect = this.customer;
        }
    },
}


</script>
